import { FaDownload } from "react-icons/fa6";
import SelectFilter from "./SelectFilter";
import TextEdit from "../molecules/TextEdit";
import { useEffect, useState } from "react";
import NewTooltip from "../atoms/NewTooltip";

import { BucketType, BUCKETS } from "../../utils/constants";


var bucketsOpts = [{
    id: BucketType.BOLETO,
    value: `https://${BUCKETS[BucketType.BOLETO]}-{{ACCOUNT}}.s3.us-east-1.amazonaws.com/`,
    label: "Boletos PDF",
}, {
    id: BucketType.BOLETO_IMAGE,
    value: `https://${BUCKETS[BucketType.BOLETO_IMAGE]}-{{ACCOUNT}}.s3.us-east-1.amazonaws.com/`,
    label: "Boletos Imagem",
}, {
    id: BucketType.DISBURSEMENT_RECEIPT,
    value: `https://${BUCKETS[BucketType.DISBURSEMENT_RECEIPT]}-{{ACCOUNT}}.s3.us-east-1.amazonaws.com/`,
    label: "Recibos desembolso",
}];

type RepositoryFileSelectProps = {
    bucketS3Account: string;
    bucketsActives: BucketType[];
    value?: string | null;
    onSelectChange: (value: string) => void;
    onTextChange: (value: string) => void;
    onDownload: () => void;
};
const RepositoryFileSelect = ({
    bucketS3Account,
    bucketsActives = [],
    value,
    onSelectChange,
    onTextChange,
    onDownload,
}: RepositoryFileSelectProps) => {
    const [selectValue, setSelectValue] = useState<string>(bucketsOpts[0].value);
    const [textValue, setTextValue] = useState<string>("");

    useEffect(() => {

        bucketsOpts.forEach((opt) => {
            opt.value = opt.value.replace("{{ACCOUNT}}", bucketS3Account);
        });

        bucketsActives.forEach((bucket) => {
            const bucketOpt = bucketsOpts.find(opt => opt.id === bucket);
            if (bucketOpt) {
                setSelectValue(bucketOpt.value);
            }
        });
    }, []);

    useEffect(() => {
        if (value) {
            const lastSlash = value.lastIndexOf("/");
            setSelectValue(value.substring(0, lastSlash + 1));
            setTextValue(value.substring(lastSlash + 1));
        }
    }, [value]);

    useEffect(() => {
        if (onTextChange)
            onTextChange(selectValue + textValue);

    }, [selectValue, textValue]);

    const handleSelectChange = (value: string) => {
        setSelectValue(value);
        if (textValue) {
            const fullUrl = value + textValue;
            if (onSelectChange)
                onSelectChange(fullUrl);
        }
    };

    const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;

        if (newValue.includes("/")) {
            const lastSlash = newValue.lastIndexOf("/");
            setTextValue(newValue.substring(lastSlash + 1).trim());
        } else {
            setTextValue(newValue.trim());
        }
    };

    const handlePaste = async (e: React.ClipboardEvent<HTMLInputElement>) => {
        const pastedText = e.clipboardData.getData("text");

        if (pastedText.includes("/")) {
            const lastSlash = pastedText.lastIndexOf("/");
            setSelectValue(pastedText.substring(0, lastSlash + 1).trim());
            setTextValue(pastedText.substring(lastSlash + 1).trim());
        }
    };

    const downloadFile = () => {
        if (!selectValue || !textValue) return;
        const fullUrl = selectValue + textValue;
        console.log("Iniciando download do arquivo:", fullUrl);
        if (onDownload)
            onDownload();
    };

    return (
        <div className="flex gap-2 w-full">
            <SelectFilter
                id="field-type"
                value={selectValue}
                onChange={handleSelectChange}
                label="Repositório"
                options={bucketsOpts.map(opt => ({
                    value: opt.value,
                    label: opt.label,
                    disabled: !bucketsActives.includes(opt.id),
                }))}
                className="w-64"
            />

            <TextEdit
                label="Nome do arquivo"
                value={textValue}
                onChange={handleTextChange}
                onPaste={handlePaste}
                placeholder=" "
                className="w-full"
            />

            <NewTooltip content="Download do arquivo" alignment="top" className="flex">
                <button
                    disabled={true}
                    type="button"
                    onClick={downloadFile}
                    className="flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700 transition disabled:text-gray-400 disabled:cursor-not-allowed"
                >
                    <FaDownload />
                </button>
            </NewTooltip>
        </div>
    );
};

export default RepositoryFileSelect;